// extracted by mini-css-extract-plugin
export default {"signUpForm":"SignUp_signUpForm__6oROZ","error":"SignUp_error__odLEh"};